import React from 'react'

const TotalSpendIcon = () => {
  return (
    <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1111 11.2778C11.1111 10.5104 8.93474 9.88888 6.25001 9.88888M11.1111 11.2778C11.1111 12.0451 8.93474 12.6667 6.25001 12.6667C3.56529 12.6667 1.3889 12.0451 1.3889 11.2778M11.1111 11.2778V14.7062C11.1111 15.4972 8.93474 16.1389 6.25001 16.1389C3.56529 16.1389 1.3889 15.4979 1.3889 14.7062V11.2778M11.1111 11.2778C13.7667 11.2778 15.9722 10.5923 15.9722 9.88888V2.94443M6.25001 9.88888C3.56529 9.88888 1.3889 10.5104 1.3889 11.2778M6.25001 9.88888C3.18196 9.88888 0.694458 9.20346 0.694458 8.49999V5.02776M6.25001 3.63888C3.18196 3.63888 0.694458 4.2604 0.694458 5.02776M0.694458 5.02776C0.694458 5.79513 3.18196 6.41665 6.25001 6.41665C6.25001 7.12013 8.50904 7.80554 11.1646 7.80554C13.8202 7.80554 15.9722 7.12013 15.9722 6.41665M15.9722 2.94443C15.9722 2.17707 13.8195 1.55554 11.1646 1.55554C8.50974 1.55554 6.35696 2.17707 6.35696 2.94443M15.9722 2.94443C15.9722 3.71179 13.8195 4.33332 11.1646 4.33332C8.50974 4.33332 6.35696 3.71179 6.35696 2.94443M6.35696 2.94443V10.0042"
      stroke="#BF740A"
      strokeWidth="1.38889"
    />
  </svg>
  )
}

export default TotalSpendIcon